/**
 * A global configuration object that will be used to manipulate the new version
 * detection configuration.
 */
const defaultVersionCacheConfig = {
  duration: 1000 * 60 * 5,
  auto: false,
  storageKey: 'AstroKong-SalesWeb-Version',
  basePath: '',
};

export default defaultVersionCacheConfig;
